module.exports = __webpack_public_path__ + "static/thumbnail-f80edff26e18b81d24cf265d4c467edf.png";